import { OverlayType } from '../../constants/common'
import BaseConfig from './overlayBaseConfig'

export class NoneConfig extends BaseConfig {
  static type = OverlayType.None
  static abbreviation = 'none'
  static label = 'None'
  static shortLabel = 'None'
}
